export default __webpack_public_path__ + "025fefdafb336c31b8d29631ea9b30b0.svg";